import { UIRouterGlobals } from "@uirouter/angular";
import { ChangeDetectionStrategy, Component, ViewChild } from "@angular/core";
import { Validators } from "@angular/forms";
import { FormGroupComponent } from "@webapp/shared/form/form-group.component";

@Component({
  selector: "create-okr-form",
  templateUrl: "./create-okr-form.component.html",
  styleUrls: ["./create-okr-form.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateOkrFormComponent {
  @ViewChild(FormGroupComponent)
  public form: FormGroupComponent<{
    sessionId: string;
    name: string;
  }>;

  public sessionId: string;

  public readonly okrNameMaxCharsCount = 255;
  public okrNameValidators = [Validators.maxLength(this.okrNameMaxCharsCount)];

  public constructor(private routerGlobals: UIRouterGlobals) {
    this.sessionId = this.routerGlobals.params["planningSessionId"];
  }

  public submitForm(): void {
    // eslint-disable-next-line no-console
    console.log(this.form.value);
  }
}
